
export const billerCrossReferenceInitialState = {

    bcrData: null,
    bcrDataError: null
};

export default function billerCrossReferenceReducer(
    state = billerCrossReferenceInitialState,
    action
) {
    switch (action.type) {


        case "GET_BILLER_CROSS_REFERENCE_SUCCESS":
            return {
                action: action.type,
                bcrData: action.data.data,
                bcrDataError: null,
                bcrDetails: action.data.bcrDetails,
            };

        case "GET_BILLER_CROSS_REFERENCE_ERROR":
            return {
                action: action.type,
                bcrData: null,
                bcrDataError: action.error };

        default:
            return state;
    }
}